import React from 'react';
import {
  Box,
  Heading,
  Text,
  Stack,
  Button,
  Input,
  FormControl,
  FormLabel,
  Divider,
  useToast,
} from '@chakra-ui/core';
import { connect } from 'react-redux';

import { useHistory } from 'react-router-dom';

import {
  getProfile,
  updateProfile,
} from '../redux/actions/profileUpdateAction';
import { changePassword } from '../redux/actions/updatePasswordAction';
import Head from '../util/Head';

function Profile({
  auth,
  getProfile,
  profil,
  updateProfile,
  loading,
  changePassword,
  data,
}) {
  const toast = useToast();
  const history = useHistory();

  //   (profil);
  const [edite, setedite] = React.useState(false);
  const [profile, setprofile] = React.useState({
    name: profil && profil.name,
    email: profil && profil.email,
    phone: profil && profil.phone,
    adress: profil && profil.adress,
    province: profil && profil.province,
  });
  const [updatePassword, setUpdatePassword] = React.useState({
    password: '',
    new_passowrd: '',
    new_password_confirmation: '',
  });

  const handleEdite = () => {
    edite ? setedite(false) : setedite(true);
  };

  const handleChange = e => {
    e.persist();
    setprofile(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handlePasswordChange = e => {
    e.persist();
    setUpdatePassword(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  React.useEffect(() => {
    if (!auth.data && !auth.loading) {
      history.push('/');
    } else {
      getProfile();
    }
  }, [updatePassword]);

  return (
    <Box
      //   bg="white"
      mt="100px"
      mr={['10px', '10px', '50px', '50px']}
      ml={['10px', '10px', '50px', '50px']}
      mb="100px"
      p="20px"
      pl={['5%', '5%', '20%', '20%']}
      pr={['5%', '5%', '20%', '20%']}
      //   w="50%"
    >
      <Head title="Profile"></Head>

      {profil && !auth.loading && (
        <>
          {!edite ? (
            <>
              <Box m="6" textAlign="center">
                <Heading>profile</Heading>
              </Box>
              <Box p="50px" bg="white" rounded="15px" shadow="lg" color="black">
                <Text fontSize="xl">name : {profil.name}</Text>
                <Divider mt="1" mb="1" borderBottom="3px solid #eee"></Divider>
                <Text fontSize="xl">email : {profil.email}</Text>
                <Divider mt="1" mb="1" borderBottom="3px solid #eee"></Divider>
                <Text fontSize="xl">adress : {profil.adress}</Text>
                <Divider mt="1" mb="1" borderBottom="3px solid #eee"></Divider>
                <Text fontSize="xl">phone : {profil.phone}</Text>
                <Divider mt="1" mb="1" borderBottom="3px solid #eee"></Divider>
                <Text fontSize="xl">province : {profil.province}</Text>
                <Divider mt="1" mb="1" borderBottom="3px solid #eee"></Divider>
                <Box display="flex" mt="10" justifyContent="flex-end">
                  <Button variant="link" onClick={handleEdite} color="blue.600">
                    éditer
                  </Button>
                </Box>
              </Box>
              <Box
                mt="4"
                p="50px"
                bg="white"
                rounded="15px"
                shadow="lg"
                color="black"
              >
                <FormControl m="4">
                  <FormLabel>Current Password</FormLabel>

                  <Input
                    borderColor="#eee"
                    border="3px solid #eee"
                    onChange={handlePasswordChange}
                    value={updatePassword.password}
                    name="password"
                    placeholder="Current Password"
                  />
                </FormControl>
                <FormControl m="4">
                  <FormLabel>New Password</FormLabel>
                  <Input
                    borderColor="#eee"
                    border="3px solid #eee"
                    onChange={handlePasswordChange}
                    value={updatePassword.new_password}
                    name="new_password"
                    placeholder="New Password"
                  />
                </FormControl>
                <FormControl m="4">
                  <FormLabel>Confirm New Password</FormLabel>
                  <Input
                    borderColor="#eee"
                    border="3px solid #eee"
                    onChange={handlePasswordChange}
                    value={updatePassword.new_password_confirmation}
                    name="new_password_confirmation"
                    placeholder="Confirm New Password"
                  />
                </FormControl>
                <Box mt="4" display="flex" justifyContent="flex-end">
                  <Button
                    m="4"
                    isLoading={loading}
                    onClick={async () => {
                      await changePassword(updatePassword);

                      setUpdatePassword({
                        password: '',
                        newPassword: '',
                        newPasswordConfirmation: '',
                      });
                      if (data.data === 'Password changed') {
                        toast({
                          position: 'top-right',
                          title: 'Password changed',

                          status: 'success',
                          duration: 4000,
                          isClosable: true,
                        });
                      } else {
                        toast({
                          position: 'top-right',
                          title: 'Password dose not match',

                          status: 'error',
                          duration: 4000,
                          isClosable: true,
                        });
                      }
                    }}
                    type="submit"
                    _hover={{ bg: 'red.700' }}
                    bg="red.500"
                    color="white"
                    isDisabled={
                      updatePassword.password === '' ||
                      updatePassword.newPassword === '' ||
                      updatePassword.newPasswordConfirmation === ''
                    }
                  >
                    update
                  </Button>
                </Box>
              </Box>
            </>
          ) : (
            <Stack
              color="black"
              spacing={4}
              p="50px"
              bg="white"
              rounded="15px"
              shadow="lg"
            >
              {/* {props.auth.error && (
              <Box color="red.700" p="2" textAlign="center" bg="red.100">
                {props.auth.error}
              </Box>
            )} */}
              <FormControl>
                <FormLabel>Name</FormLabel>
                <Input
                  borderColor="#eee"
                  border="3px solid #eee"
                  onChange={handleChange}
                  defaultValue={profil.name}
                  name="name"
                  placeholder="Write a name"
                />
              </FormControl>
              <FormControl>
                <FormLabel>Email</FormLabel>
                <Input
                  borderColor="#eee"
                  border="3px solid #eee"
                  onChange={handleChange}
                  defaultValue={profil.email}
                  name="email"
                  placeholder="Write an email"
                />
              </FormControl>
              <FormControl>
                <FormLabel>Adress</FormLabel>
                <Input
                  borderColor="#eee"
                  border="3px solid #eee"
                  onChange={handleChange}
                  defaultValue={profil.adress}
                  name="adress"
                  placeholder="Write an adress"
                />
              </FormControl>
              <FormControl>
                <FormLabel>Phone</FormLabel>
                <Input
                  borderColor="#eee"
                  border="3px solid #eee"
                  onChange={handleChange}
                  defaultValue={profil.phone}
                  name="phone"
                  placeholder="Write your number"
                />
              </FormControl>
              <FormControl>
                <FormLabel>Province</FormLabel>
                <Input
                  borderColor="#eee"
                  border="3px solid #eee"
                  onChange={handleChange}
                  defaultValue={profil.province}
                  name="province"
                  placeholder="Write your province"
                />
              </FormControl>

              <Box display="flex" justifyContent="flex-end">
                <Button
                  //   isLoading={loading}
                  onClick={async () => {
                    // await updateProfile(profile);
                    handleEdite();
                  }}
                  type="submit"
                  colorScheme="red"
                  variant="link"
                  mr="4"
                >
                  Cancel
                </Button>
                <Button
                  isLoading={loading}
                  onClick={async () => {
                    await updateProfile(profile);
                    handleEdite();
                  }}
                  type="submit"
                  _hover={{ bg: 'red.700' }}
                  bg="red.500"
                  color="white"
                  isDisabled={
                    profile.name === '' ||
                    profile.adress === '' ||
                    profile.email === '' ||
                    profile.province === '' ||
                    profile.phone === ''
                  }
                >
                  update
                </Button>
              </Box>
            </Stack>
          )}
        </>
      )}
    </Box>
  );
}

const mapStateToProps = state => {
  return {
    // orders: state.order.orders,
    auth: state.auth,
    profil: state.profile.profile,
    loading: state.profile.loading,
    data: state.passwordUpdate,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getProfile: () => dispatch(getProfile()),
    updateProfile: profile => dispatch(updateProfile(profile)),
    changePassword: updatePassword => dispatch(changePassword(updatePassword)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
